import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';

import { TranslationModule } from '@lib/translation';
import { SnActionsModule } from '@lib/ui/actions';
import { SnButtonModule } from '@lib/ui/button';
import { SnDrawerModule } from '@lib/ui/drawer';
import { SnIconModule } from '@lib/ui/icon';

import {
  SnDataListComponent,
  SelectionBarComponent,
  SnEmptyStateComponent,
  SnPullToRefreshComponent,
  SnInfiniteScrollComponent,
} from './components';

@NgModule({
  imports: [
    CommonModule,
    // Material
    MatProgressSpinnerModule,
    // Libs
    TranslationModule,
    SnIconModule,
    SnButtonModule,
    SnActionsModule,
    SnDrawerModule,
    TranslationModule,
  ],
  exports: [
    SnDataListComponent,
    SnEmptyStateComponent,
    SelectionBarComponent,
    SnPullToRefreshComponent,
    SnInfiniteScrollComponent,
  ],
  declarations: [
    SnDataListComponent,
    SelectionBarComponent,
    SnEmptyStateComponent,
    SnPullToRefreshComponent,
    SnInfiniteScrollComponent,
  ],
})
export class SnDataListModule {}
